import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8894f132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat" }
const _hoisted_2 = { class: "chat__wrapper" }
const _hoisted_3 = { class: "chat__timestamp" }
const _hoisted_4 = { class: "chat__message" }
const _hoisted_5 = { class: "chat__input-zone" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat__send-btn" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat_log, (message) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "chat__line",
          key: message.timestamp
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(message.pseudo), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(message.message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        class: "chat__input",
        type: "text",
        placeholder: "message",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chat_message) = $event)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.chat_message]
      ]),
      _hoisted_6
    ])
  ]))
}